import styled, {css} from "styled-components";

import Smiles from '../../../assets/images/m_cnt2_smiles.svg';
import Hands from '../../../assets/images/m_cnt2_hands.svg';
import Video from '../../../assets/images/m_cnt2_video.svg';
import Files from '../../../assets/images/m_cnt2_files.svg';
import Crystals from '../../../assets/images/m_cnt2_crystals.svg';
import Sun from '../../../assets/images/m_cnt2_sun.svg';
import Moon from '../../../assets/images/m_cnt2_moon.svg';

export const Container = styled.div`
  height: 5000px;
  color: ${({theme}) => theme.colors.black};
  margin-bottom: 5vh;
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: 100%;
`

export const MobileContent = styled.div`
  height: 100%;

  @media only screen and (${({theme}) => theme.media.large}) {
    display: none;
  }
`

export const Phone = styled.img`
  width: auto;
  height: 80vh; 
  position: sticky;
  margin-left: 10vw;
  top: 10vh;

  @media only screen and (${({theme}) => theme.media.large}) {
    height: 95vh;
    margin: 10% auto;
    top: 3%;
  }
`;

const LeftLine = styled.div`
  display: table;
  position: relative;
  width: 90%;
  padding: 40px 40px 40px 200px;
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  border-left: none;
  background: ${({theme}) => theme.colors.secondaryBackground};
  border-radius: 0 40px 40px 0;
`

const RightLine = styled.div`
  display: table;
  position: relative;
  width: 90%;
  padding: 40px 240px 40px 40px;
  margin-left: 10%;
  height: 250px;
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  border-right: none;
  background: ${({theme}) => theme.colors.secondaryBackground};
  border-radius: 40px 0 0 40px;
`

const LineText = styled.div`
  color: ${({theme}) => theme.colors.secondaryFont};
`

export const LeftText = styled(LineText)`
  display: flex;
  align-items: center;
  margin-bottom: auto;
  height: 100%;
  width: 80%;
  float: left;
  position: relative;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 40px;
`

export const RightText = styled(LineText)`
  display: flex;
  align-items: center;
  margin-bottom: auto;
  height: 100%;
  width: 80%;
  float: left;
  position: relative;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 40px;
`

export const Line1 = styled(LeftLine)`
  top: 100px;

  @media only screen and (${({theme}) => theme.media.small}) {
    top: 80px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: 800px;
  }
  
  &::after {
    display: block;
    content: " ";
    background-image: url('${Smiles}');
    background-repeat: no-repeat;
    background-size: contain;
    width: 25%;
    height: 50%;
    position: absolute;
    bottom: -5%;
    right: -10%;
  }
`

export const Line2 = styled(RightLine)`
  top: 700px;

  @media only screen and (${({theme}) => theme.media.large}) {
    top: 1450px;
  }
  
  &::before {
    display: block;
    content: " ";
    background-image: url('${Moon}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 30%;
    top: -50px;
    left: -10%;
  }

  &::after {
    display: block;
    content: " ";
     background-image: url('${Sun}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 50%;
    position: absolute;
    width: 30%;
    left: 50%;
    top: 80%;
  }
`

export const Line3 = styled(LeftLine)`
  top: 1500px;

  @media only screen and (${({theme}) => theme.media.large}) {
    top: 2000px;
  }
  
  &::after {
    display: block;
    content: " ";
    background-image: url('${Hands}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 50%;
    position: absolute;
    width: 30%;
    right: -5%;
    bottom: -10%;
  }
`

export const Line4 = styled(RightLine)`
  top: 2700px;

  &::before {
    display: block;
    content: " ";
    background-image: url('${Video}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 30%;
    top: 50%;
    left: -20%;
  }
`

export const Line5 = styled(LeftLine)`
  top: 3300px;
  
  &::after {
    display: block;
    content: " ";
    background-image: url('${Crystals}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 30%;
    left: 90%;
    top: 30%;
  }
`

export const Line6 = styled(RightLine)`
  padding-right: 150px;
  top: 3900px;

  &::before {
    display: block;
    content: " ";
    background-image: url('${Files}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 30%;
    left: 50%;
    top: 80%;
  }
`